import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { RequestApiResult } from 'loopback-react-request';
// import classNames from 'classnames';

import {
  ConfigurationModel,
  TroughModel,
  WashBasinModel,
  MinMaxCurrentModel,
  calculateCenterToCenterPositions,
  inRange, TroughPositionProps, MinMaxModel
} from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import { CalculationProps } from './Distances';
import Tooltip from 'reactstrap/lib/Tooltip';
import { DebounceInput } from 'react-debounce-input';

export interface DistancesFieldsProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: RequestApiResult<ConfigurationModel>;
  disabled: boolean;
  dispatch: any;
  trough: RequestApiResult<TroughModel>;
  onChange?: (distances: number[]) => void;
}

export interface DistancesFieldsState {
  defaults?: TroughPositionProps[];
  hasError: boolean;
  spacings?: number[];
}

export class DistancesFieldsPartial extends React.Component<DistancesFieldsProps, DistancesFieldsState> {
  constructor(props: DistancesFieldsProps) {
    super(props);

    this.state = {
      hasError: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (this.props.plateBuilder) {
      this.setState({
        spacings: this.props.plateBuilder.calc.troughToTroughCenters(),
      });
    }  
  }

  componentDidUpdate() {
    if (!this.state.spacings && this.props.plateBuilder) {
      this.setState({
        spacings: this.props.plateBuilder.calc.troughToTroughCenters(),
      });
    }
  }

  public render() {
    const {
      spacings
    } = this.state;

    return (
      <div className="partial-distances-fields position-relative">
        <div className="row">
          <div className="p-0 offset-3 offset-md-2 col-6 col-md-8" id="distances_field_info">
            <div className="d-flex position-relative">
              {spacings && spacings.map((spacing, index) => {
                const key = `distances_fields_inputs_${index}`;
                return (
                  <React.Fragment key={key}>
                    <div className="partial-checkbox-positions-item position-relative" style={{flex: spacing}}>
                      <div className="form-group m-0 col-12">
                        <DebounceInput
                          className="form-control p-0 w-100 mt-3 text-center"
                          disabled={this.props.disabled}
                          name={`spacing_${index}`}
                          onChange={this.handleChange}
                          type="number"
                          value={spacing}
                          debounceTimeout={1000}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
            {this.state.hasError && (
              <span className="info-icon">
                <FontAwesomeIcon icon={faInfo} />
                <Tooltip
                  autohide={false}
                  isOpen={true}
                  placement="top"
                  target="distances_field_info"
                >
                  error
                </Tooltip>
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }

  private isValidSpacings(spacings: number[]) {
    if (!this.props.plateBuilder) { return false; } // TODO - Shouldnt be validating the spacings/distances here, should be on server
    
    let isValid = true;
    const widthRange = this.props.plateBuilder.calc.troughPositionsRange();
    const minTroughWidth = this.props.plateBuilder.calc.plateMinWidth(1);
    const troughToTroughSpace = this.props.plateBuilder.calc.troughToTroughWidth();
    const distances = this.spacingsToDistances(spacings);

    spacings.forEach((spacing, index) => {
      const distance = distances[index];
      const isFirst = index === 0;
      const isLast = index === spacings.length-1;

      let minSpace = troughToTroughSpace;

      if (isFirst) {
        minSpace = minTroughWidth.left;
      }
      if (isLast) {
        minSpace = minTroughWidth.right;
      }

      if (!distance) { return; }

      if (spacing < minSpace || distance < widthRange.min || distance > widthRange.max) {
        isValid = false;
      }
    });

    return isValid;
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const {
      spacings,
    } = this.state;


    if (!spacings) { return; }

    const target = event.target as HTMLInputElement,
      name = target.name,
      value = Math.round(Number(target.value)),
      index = Number(name.split('_')[1]),
      currentValue = spacings[index];

    // Technically the last spacing doesnt exist in the config model, so we instead adjust the 2nd to last spacing
    const isLastSpacing = index === spacings.length-1;
    if (isLastSpacing) { 
      const difference = currentValue - value;
      spacings[index-1] = spacings[index-1] + difference;
    }

    spacings[index] = value;

    if (!this.isValidSpacings(spacings)) { return; }

    this.setState({
      spacings,
    });

    if (this.props.onChange) {
      const distances = this.spacingsToDistances(spacings);
      this.props.onChange(distances);
    }
  }

  private spacingsToDistances(spacings: number[]) {
    let distances: number[] = [];

    spacings.forEach((spacing, index) => {
      let distance = spacing;

      if (distances[index-1]) {
        distance = distance + distances[index-1];
      }

      distances.push(distance);
    });

    distances.pop();

    return distances;
  }
}

export const DistancesFields = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
  trough: state.trough,
}))(DistancesFieldsPartial);

export default DistancesFields;